import React from 'react';
import AppRouter from '@/router/AppRouter';

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
